// deleteMeetingFromTrip — pure builder that removes a meeting from the edited trip.
//
// Extracted verbatim from `EditTripModal.js` (the `editedTrip.meetings.filter(...)`
// inside `handleDeleteMeeting` that runs after the user confirms) as part of the
// behavior-preserving refactor (issue #240). It immutably builds the next trip
// with every meeting whose `id` does NOT match `meetingId` retained.
//
// Totality preserved exactly: the source read `editedTrip.meetings` directly
// (guaranteed an array by `initializeEditedTrip`); this builder mirrors that with
// no added guard. The `findMeetingById` lookup, the `window.confirm` gate, and
// the state update stay in the hook/container — this function models only the
// post-confirmation next-trip computation.
//
// React-free and side-effect-free.
//
// Validates: Requirements 3.1, 3.4, 3.5, 1.6

/**
 * Returns the next edited trip with the meeting matching `meetingId` removed.
 *
 * @param {Object} editedTrip - The current edited-trip working copy.
 * @param {*} meetingId - The `id` of the meeting to remove.
 * @returns {Object} The next edited-trip object.
 */
export function deleteMeetingFromTrip(editedTrip, meetingId) {
  const updatedMeetings = editedTrip.meetings.filter(meeting => meeting.id !== meetingId);
  return {
    ...editedTrip,
    meetings: updatedMeetings
  };
}

export default deleteMeetingFromTrip;
